import { Sentry } from "@clcdev/sentry";
export default Sentry;
